import SeminarBlock from "./Home/SeminarBlock";
import NewsBlock from "./Home/NewsBlock";

const Syllabus = (props) => {

    const {baseUrl, toDownload} = props;
    
    return(
        <>
            <div className="row" style={{ position: "relative"}}>
                <div className="col s12">
                    <h4 className="home_title"> Seminar </h4>
                    <div className='collection home_list'>
                        <SeminarBlock csvFilePath={baseUrl+"seminar_list.csv"} toDownload={toDownload} />
                    </div>
                </div>
                <div className="col s12">
                    <h4 className="home_title"> News </h4>
                    <div className='collection home_list'>
                        <NewsBlock csvFilePath={baseUrl+"news_list.csv"} toDownload={toDownload} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default Syllabus;
